// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__jw4hK","time":"styles_time__2PxnS"};